export default __webpack_public_path__ + "static/media/cc.bd16a37d.svg";